module.exports = __webpack_public_path__ + "static/img/animales_32.2e810338.png";